import React from 'react'
import team  from "../assets/team.webp";

interface MissionProps {
  alignmentClasses: string;
}

export default function Mission({ alignmentClasses }: MissionProps) {
  return (
    <div className={alignmentClasses}>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-16 pb-16">
            <div className="col-span-1 flex items-center justify-center">
                <img src={team} alt="Team" className="w-[200px] md:w-[300px] h-full object-cover rounded-[30px]" />
            </div>
            <div className="col-span-1">
                <h2 className="text-center sm:text-left text-3xl font-bold font-noto font-italic leading-relaxed">Our Mission</h2>
                <p className="text-center sm:text-left text-lg pr-2 pl-0 sm:pr-16 sm:pl-0">We believe that wellness is a journey, not a destination. It's about finding balance, healing, and growth in every moment. Our mission is to provide accessible, transformative experiences that nourish the mind, body, and soul.</p>
            </div>
        </div>
      
    </div>
  )
}
